import { useRef } from 'react';

export const useSingleSubmit = () => {
  const isSubmittingRef = useRef(false);

  const canSubmit = () => {
    if (isSubmittingRef.current) return false;
    isSubmittingRef.current = true;
    return true;
  };

  const resetSubmit = () => {
    isSubmittingRef.current = false;
  };

  return { canSubmit, resetSubmit };
};